import { defineStore } from "pinia";
import Vue, { ref } from "vue";
import axios from "axios";
import i18n from "@/i18n";
import { POSITION, TYPE } from "vue-toastification";
import { Molecule, MoleculeInfo } from "@/model/molecule";

export const useMoleculeStore = defineStore("molecule", () => {
  const molecule = ref<MoleculeInfo>({
    families: [],
    patent: "",
    sources: [],
    id: -1,
    name: "",
    casNumber: "",
    other: "",
    chemicalFormula: "",
    unamiPerception: "",
    generalTaste: "",
    dosage: "",
    process: "",
    labelling: "",
    biologicalSource: "",
    type: "",
  });
  const molecules = ref<Molecule[]>([]);

  const getMolecules = async (query?: any) => {
    await axios
      .get<Molecule[]>("/molecule", { params: query })
      .then((res) => (molecules.value = res.data));
  };
  const getMoleculeById = async (id: number) => {
    await axios
      .get<MoleculeInfo>(`/molecule/${id}`)
      .then((res) => (molecule.value = res.data));
  };
  const addMolecule = async () => {
    await axios
      .post<Molecule>("/molecule", { ...molecule.value })
      .then((res) => {
        molecules.value.push(res.data);
        Vue.$toast(i18n.t("molecule.toast.add.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("molecule.toast.add.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  const updateMolecule = async () => {
    await axios
      .patch<MoleculeInfo>(`/molecule/${molecule.value.id}`, molecule.value)
      .then(() => {
        Vue.$toast(i18n.t("molecule.toast.update.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("molecule.toast.update.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  const deleteMolecule = async (id) => {
    await axios
      .delete(`/molecule/${id}`)
      .then((res) => {
        const idx: number = molecules.value.findIndex(
          (item) => item.id === res.data.id
        );
        molecules.value.splice(idx, 1);
        Vue.$toast(i18n.t("molecule.toast.delete.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("molecule.toast.delete.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  return {
    molecule,
    molecules,
    getMolecules,
    getMoleculeById,
    addMolecule,
    updateMolecule,
    deleteMolecule,
  };
});
